"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDiv = exports.StyledButton = exports.EscalationIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var StyledButton = exports.StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-5n00p7-0"
})(["border-width:1px 1px 0px 1px;border-style:solid;border-color:#ececec;border-radius:4px 4px 0px 0px;font-family:'Lato';font-style:normal;font-weight:600;font-size:16px;line-height:24px;cursor:", ";background-color:", ";color:", ";padding:0 10px;width:", ";height:", ";align-self:flex-end;"], function (_ref) {
  var checkEscalated = _ref.checkEscalated;
  return checkEscalated ? '' : 'pointer';
}, function (_ref2) {
  var checkEscalated = _ref2.checkEscalated;
  return checkEscalated ? '#FDD1D1' : ' #FFFFFF';
}, function (_ref3) {
  var checkEscalated = _ref3.checkEscalated;
  return checkEscalated ? '#F31414' : '#757575';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile ? '' : '159px';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return isMobile ? '32px' : '40px';
});
var EscalationIcon = exports.EscalationIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'report-issue'
}).withConfig({
  displayName: "styles__EscalationIcon",
  componentId: "sc-5n00p7-1"
})(["height:", ";width:", ";margin-right:", ";margin-bottom:", ";"], function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? '19px' : '20px';
}, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile ? '17px' : '20px';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile ? '5px' : '10px';
}, function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? '4px' : '3px';
});
var StyledDiv = exports.StyledDiv = _styledComponents["default"].div.withConfig({
  displayName: "styles__StyledDiv",
  componentId: "sc-5n00p7-2"
})(["font-family:'Lato';font-style:normal;font-weight:400;font-size:", ";line-height:24px;display:inline;"], function (_ref10) {
  var isMobile = _ref10.isMobile;
  return isMobile ? '14px' : '16px';
});
//# sourceMappingURL=styles.js.map